module.exports = __webpack_public_path__ + "img/uchechukwu-azubuko-logo.156d3f5e.png";